<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="400"
  >
    <v-card>
      <v-card-title class="headline">
        {{ $t('GAME.CARDS.CLASS_MODE.HOW_MANY_TEAMS') }}
      </v-card-title>
      <v-card-text>
        <v-row class="mt-4">
          <v-col>
            <BaseButton @click="setTeams(2)">
              2
            </BaseButton>
          </v-col>
          <v-col>
            <BaseButton @click="setTeams(3)">
              3
            </BaseButton>
          </v-col>
          <v-col>
            <BaseButton @click="setTeams(4)">
              4
            </BaseButton>
          </v-col>
        </v-row>

        <div class="text-center">
          {{ $t('GAME.CARDS.CLASS_MODE.OR') }}
        </div>

        <v-row>
          <v-col>
            <BaseButton color="white" @click="setTeams(1)">
              {{ $t('GAME.CARDS.CLASS_MODE.ONE_TEAM') }}
            </BaseButton>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="darken-1"
          text
          @click="close"
        >
          {{ $t('BACK') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CardsCreateTeams',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    code: '',
  }),
  methods: {
    close() {
      this.$router.push({ name: 'home' });
    },
    setTeams(teams) {
      this.$store.dispatch('classMode/cardsTeams', teams);
    },
  },
};
</script>
